import React, { useMemo, useState } from "react"
import { Alert, Container } from "reactstrap"
import { useQuery } from "@tanstack/react-query"
import { Link } from "react-router-dom"

import storage from "services/storage"
import { authUserKey } from "config/API"
import "assets/scss/custom/components/periodic-task.scss"
import { CashMovementsChart } from "components/periodicTasks"
import { getCashMovemnts } from "services/tickets"
import ListFilterBar from "ui-componets/list-filter-bar"
import { getDatePresetRange } from "utils/date-filters"
import { getStoredAdjustmentLimit, setStoredAdjustmentLimit } from "utils/cash-movement-analysis"

const defaultDateFilter = { preset: "year", ...getDatePresetRange("year") }

const CashMovementsChartHistory = () => {
  document.title = "Analisis grafico de ajustes | Punto de venta"
  const permissions = storage.get(authUserKey).user_permissions || []
  const [adjustmentLimit, setAdjustmentLimit] = useState(getStoredAdjustmentLimit())
  const [dateFilter, setDateFilter] = useState(defaultDateFilter)

  const adjustmentQueryParams = useMemo(
    () => {
      const params = {
        ordering: "created_at",
        per_page: 200,
        offset: 0,
        movement_type: "adjustment",
      }

      if (dateFilter?.startDate) {
        params.date__gte = dateFilter.startDate
      }

      if (dateFilter?.endDate) {
        params.date__lte = dateFilter.endDate
      }

      return params
    },
    [dateFilter]
  )

  const adjustmentMovementsQuery = useQuery(
    ["cash-movements-chart-history", "adjustments", dateFilter],
    () => getCashMovemnts(adjustmentQueryParams),
    {
      refetchOnMount: "always",
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      staleTime: 0,
    }
  )
  return !permissions.some((e) => e.codename === "view_cashcut") ? (
    <div className="page-content">
      <div className="text-center">
        <h1>No autorizado para ver esta pagina</h1>
      </div>
    </div>
  ) : (
    <div className="page-content" style={{ paddingTop: "1rem" }}>
      <Container fluid>
        {adjustmentMovementsQuery.isError && (
          <Alert color="danger">
            {[adjustmentMovementsQuery.error]
              .filter(Boolean)
              .flatMap((item) => item?.errors?.map((error) => error?.message) || [])
              .join(" ")}
          </Alert>
        )}

        <div className="p-4 rounded">
          <div className="d-flex align-items-center gap-3 mb-3 flex-wrap pt-5">
            <Link to="/cash-movements-history" className="btn btn-primary">
              <i className="fa fa-arrow-left" /> Volver
            </Link>
            <div>
              <h4 className="mb-1">Analisis grafico de ajustes de caja</h4>
              <p className="text-muted mb-0">Revisa variaciones, tendencia y limites acumulados.</p>
            </div>
          </div>

          <div className="mb-4">
            <ListFilterBar
              dateFilter={dateFilter}
              onDateFilterChange={setDateFilter}
              onClear={() => setDateFilter({ preset: "", startDate: "", endDate: "" })}
              autoApply={true}
            />
          </div>

          <CashMovementsChart
            adjustmentMovements={adjustmentMovementsQuery.data?.results || []}
            adjustmentLimit={adjustmentLimit}
            onAdjustmentLimitChange={(value) => {
              const nextLimit = setStoredAdjustmentLimit(value)
              setAdjustmentLimit(nextLimit)
            }}
            isLoading={adjustmentMovementsQuery.isLoading || adjustmentMovementsQuery.isFetching}
          />
        </div>
      </Container>
    </div>
  )
}

export default CashMovementsChartHistory
